import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { AudioLines, Loader2 } from 'lucide-react';
import { catalogue, ttsCall, ttsReady, TTS_LANGS } from '../lib/helpAudio';
import { I18N } from '../lib/i18n';

const wait = (ms) => new Promise((ok) => setTimeout(ok, ms));

// owner: notice when help texts have no recording yet; one tap voices all (batch after batch until done)
export default function TtsNotice({ t }) {
  const x = (k) => t[k] || I18N.en[k], [plan, setPlan] = useState(null), [run, setRun] = useState(null);
  const items = () => catalogue().items;
  const load = () => ttsCall('/plan', { method: 'POST', body: JSON.stringify({ items: items() }) }).then((p) => { setPlan(p); return p; }).catch(() => null);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const all = async () => {
    if (!window.confirm(x('tnAsk').replace('{n}', plan.missing).replace('{c}', plan.chars.toLocaleString()))) return;
    let p = plan, fails = 0;
    try {
      for (let round = 0; round < 40 && p.missing - p.failed.length > 0; round += 1) {
        const r = await ttsCall('/run', { method: 'POST', body: JSON.stringify({ items: items() }) });
        if (!r.started) break;
        let s = { on: true, done: 0, left: r.started };
        while (s.on) { setRun({ ...s, total: p.missing }); await wait(2500); s = (await ttsCall('/status').catch(() => null)) || s; }
        fails = s.failed || 0; p = (await load()) || p;
      }
      TTS_LANGS.forEach((l) => ttsReady(l, true));
      toast.success(p.missing ? x('tnFail').replace('{n}', p.missing) : x('tnDone'));
    } catch (e) { toast.error(String(e.message)); }
    setRun(null); if (fails) load();
  };
  if (!plan || (!plan.missing && !run)) return null;
  return (
    <section className="set-sec tts-notice" data-testid="tts-notice">
      <AudioLines size={18} />
      <div>
        <b data-testid="tts-notice-count">{x('tnNew').replace('{n}', plan.missing)}</b>
        <span className="muted small-hint" data-testid="tts-notice-chars">{x('tnChars').replace('{c}', plan.chars.toLocaleString())}</span>
        {run && <span className="small-hint" data-testid="tts-notice-progress"><Loader2 size={12} className="spin" /> {x('tnRun').replace('{d}', run.done || 0).replace('{l}', run.left ?? '…')}</span>}
      </div>
      <button className="btn btn-green btn-sm" data-testid="tts-notice-run-btn" disabled={!!run} onClick={all}>{x('tnGo')}</button>
    </section>
  );
}
